import PropTypes from 'prop-types'
import { Button, Card, CardContent, Grid, Typography } from '@mui/material'
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded'

export default function GetLead({ disabled, onClick }) {
  return (
    <Grid item xs={12}>
      <Card>
        <CardContent sx={{ mb: 1 }}>
          <Grid container>
            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography sx={{ fontSize: 14 }} color="text.secondary">
                Get new lead
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              <Button
                disabled={disabled}
                endIcon={<ArrowForwardIosRoundedIcon />}
                onClick={onClick}
              >
                Get lead
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  )
}

GetLead.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
}
